import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';
import { motion } from 'framer-motion';
import Option from './option';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const option = {
  hidden: { opacity: 0, x: -20 },
  show: { opacity: 1, x: 0 }
};

const ColorOptionsContainer = styled(motion.div)`
  display: flex;
  position: relative;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 290px;
  background: ${th('colors.transparentWhite.5')};
  padding: 10px 9px;
  padding-right: 0;
  padding-bottom: 0;
  border-radius: 8px;
  margin-left: 5%;

  @media ${sizes.desktop} {
    flex-direction: column;
    margin-left: 0;
    padding-right: 9px;
  }
`;

const ColorOptions = ({ items, name, config, updateConfig }) => {
  const [selectedOption, setSelectedOption] = useState(config[name]);

  useEffect(() => {
    setSelectedOption(config[name]);
  }, [config, name]);

  return (
    <ColorOptionsContainer variants={container} initial="hidden" animate="show">
      {items.map((item) => (
        <motion.div variants={option} key={`option-${item}`}>
          <Option
            item={item}
            isActive={selectedOption === item}
            onClick={() => updateConfig({ ...config, [name]: item })}
          />
        </motion.div>
      ))}
    </ColorOptionsContainer>
  );
};

ColorOptions.propTypes = {
  items: PropTypes.array,
  name: PropTypes.string,
  config: PropTypes.object,
  updateConfig: PropTypes.func
};

export default ColorOptions;
